import LaunchOutlined from "@mui/icons-material/LaunchOutlined";
import { Box, Typography, Link, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { useNavigate } from "react-router-dom";

const NiceLink = ({ label, link, tip, showFollowIcon, makeBlue, onClick }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      gap=".4rem"
      style={{
        // whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width:"100%",
      }}
    >
      <Link
        to={link}
        component={onClick ? "button" : RouterLink}
        underline="hover"
        color={makeBlue ? "blue" : "inherit" }
        fontSize="inherit"
        onClick={handleClick}
        sx={onClick ? {
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          textAlign: "left"
        } : undefined}
      >
        <Tooltip title={tip}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            gap=".2rem"
          >
            <Typography fontSize="inherit">{label}</Typography>

            {showFollowIcon && (
              <LaunchOutlined
                fontSize="inherit"
                aria-label="follow"
                onClick={(e) => {
                  e.stopPropagation();
                  if (onClick) {
                    onClick(e);
                  } else {
                    navigate(link);
                  }
                }}
              ></LaunchOutlined>
            )}
          </Box>
        </Tooltip>
      </Link>
    </Box>
  );
};

export default NiceLink;
